import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useFetch } from "@/hooks/useFetch";
import ContentPage from "./ContentPage";

function FaqList() {
  const { data: faqs } = useFetch("/faqs");
  const [open, setOpen] = useState(0);
  return (
    <div className="mt-6 divide-y divide-[color:var(--line)] border-y border-[color:var(--line)]" data-testid="faq-list">
      {(faqs || []).map((f, i) => (
        <div key={f.id}>
          <button onClick={() => setOpen(open === i ? -1 : i)} aria-expanded={open === i} className="flex w-full items-center justify-between gap-4 py-5 text-left" data-testid={`faq-q-${i}`}>
            <h2 className="font-display text-xl font-semibold uppercase text-white">{f.question}</h2>
            <ChevronDown className={`h-4 w-4 shrink-0 text-[color:var(--ice)] transition-transform duration-300 ${open === i ? "rotate-180" : ""}`} />
          </button>
          {open === i && <p className="pb-6 text-slate-300" data-testid={`faq-a-${i}`}>{f.answer}</p>}
        </div>
      ))}
    </div>
  );
}

export default function FaqPage() {
  return <ContentPage pageKey="faq" extra={<FaqList />} />;
}
